// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"9f7dd30e","648":"d866edcc","868":"ca569c54","921":"2c557668"}[chunkId] + ".chunk.css";
};